import styled from 'styled-components'
import LazyLoad from 'react-lazy-load'

const FlexLazyLoad = styled(LazyLoad)`
  display: flex;
  flex: 1;
`

FlexLazyLoad.displayName = 'FlexLazyLoad'

export default FlexLazyLoad
